import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EventTypeModel } from 'src/app/models/events/event-type.model';
import { TopRecordsModel } from 'src/app/models/top-records/top-records.model';
import { TopTopicModel } from 'src/app/models/top-records/top-topic.model';
import { DashboardWidgetsDataService } from 'src/app/services/dashboard-widget-data.service';

@Component({
  selector: 'app-top-10-records-widget',
  templateUrl: './top-10-records-widget.component.html',
  styleUrl: './top-10-records-widget.component.scss',
  standalone: false
})
export class Top10RecordsWidgetComponent {
  top10Records!: TopRecordsModel;
  top10RecordsData: TopRecordData[] = [];

  selectedTabIndex = 0;

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private toastrService: ToastrService,
    private dashboardWidgetsDataService: DashboardWidgetsDataService
  ) {

  }

  ngOnInit() {
    this.dashboardWidgetsDataService.getTop10Records().subscribe(data => {
      if (data) {
        this.top10Records = data;
        this.top10RecordsData = [
          {
            text: this.translateService.instant('TOP-10.TOP-10-PERSONS'),
            data: data.topPersons.map((item) => ({
              ...item,
              id: item.personId
            })),
            columns: [
              { dataField: 'rank', caption: '#', disableFiltering: true },
              {
                dataField: 'email',
                caption: this.translateService.instant('COMMON.FIELDS.EMAIL'),
                disableFiltering: true
              },
              {
                dataField: 'completionsCount',
                caption: this.translateService.instant('TOP-10.COUNT-OF-COMPLETIONS'),
                disableFiltering: true
              }
            ],
            commands: (id: string): string[]|null => ['employee', 'edit', id],
          },
          {
            text: this.translateService.instant('TOP-10.TOP-10-TOPICS'),
            data: data.topTopics.map((item) => ({
              ...item,
              id: item.topicId
            })),
            columns: [
              { dataField: 'rank', caption: '#', disableFiltering: true },
              {
                dataField: 'title',
                caption: this.translateService.instant('COMMON.FIELDS.TITLE'),
                disableFiltering: true
              },
              {
                dataField: 'type',
                caption: this.translateService.instant('COMMON.FIELDS.TYPE'),
                calculateDisplayValue: (rowData: TopTopicModel) => {
                  switch(rowData.type) {
                    case 3: return this.translateService.instant('COMMON.FIELDS.EVENT-TYPES.EXTERNAL');
                    case 4: return this.translateService.instant('COMMON.FIELDS.EVENT-TYPES.ELEARNING');
                    case 5: return 'gut beraten';
                    case 0: return rowData.location;
                    default: return this.translateService.instant('COMMON.UNKNOWN');
                  }
                },
                disableFiltering: true
              },
              {
                dataField: 'completionsCount',
                caption: this.translateService.instant('TOP-10.COUNT-OF-COMPLETIONS'),
                disableFiltering: true
              },
              {
                dataField: 'previousYearCompletionsCount',
                caption:  this.translateService.instant('TOP-10.PREVIOUS-YEAR-COMPLETIONS'),
                disableFiltering: true
              },
              {
                dataField: 'percentCompletionsChangeFromLastYear',
                caption: '%',
                cellTemplate: 'percent',
                disableFiltering: true
              }
            ],
            commands: (id: string): string[]|null => {
              const topTopic = this.top10Records.topTopics.find(x => x.topicId == id)!;
              const topicType = topTopic.type;

              if(topicType == EventTypeModel.External) {
                this.toastrService.warning(
                  this.translateService.instant('TOP-10.CANNOT-GUITE-TO-TRAINING')
                );
                return null;
              }

              const path = topicType == EventTypeModel.Webinar ? 'manage-elearning' : 'training';
              return [path, id]
            }
          },
          {
            text: this.translateService.instant('TOP-10.TOP-10-CATEGORIES'),
            data: data.topCategories.map((item) => ({
              ...item,
              id: item.categoryId
            })),
            columns: [
              { dataField: 'rank', caption: '#', disableFiltering: true },
              {
                dataField: 'name',
                caption: this.translateService.instant('COMMON.FIELDS.CATEGORY'),
                disableFiltering: true
              },
              {
                dataField: 'completionsCount',
                caption: this.translateService.instant('TOP-10.COUNT-OF-COMPLETIONS'),
                disableFiltering: true
              }
            ],
            commands: (id: string): string[]|null => ['administration', 'training-categories', id],
          }
        ];
      }
    });
  }

  onTabChange(event: any): void {
    this.selectedTabIndex = event.itemIndex;
  }

  onTopRecordClick(id: string) {
    const tab: TopRecordData = this.top10RecordsData[this.selectedTabIndex];
    const commands = tab.commands;
    if (commands) {
      const result = commands(id);
      if(result) {
        this.router.navigate(result);
      }
    }
  }
}

interface TopRecordData {
  text: string;
  data: any[];
  columns: any[];
  commands?:  (id: string) => string[]|null;
}